import React from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import AttributeButton from '../AttributeButton/AttributeButton';
import AttributeDropDown from '../AttributeDropDown/AttributeDropDown';
import ProductDetailSwatches from '../ProductDetailSwatches/ProductDetailSwatches';

export class ProductDetailAttribute extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSizes: false,
      productId: this.props.contentData.productId,
      selectedAttributeValue: '',
      isAvailable: true,
    };
    this.openSizeChart = this.openSizeChart.bind(this);
    this.openSizeChartKeypress = this.openSizeChartKeypress.bind(this);
    this.getAvailableValues = this.getAvailableValues.bind(this);
    this.getPricing = this.getPricing.bind(this);
    this.buildPriceObj = this.buildPriceObj.bind(this);
    this.getOneAttrPricing = this.getOneAttrPricing.bind(this);
  }

  openSizeChartKeypress(event) {
    if (event.key == 'Enter') {
      this.openSizeChart();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if ((this.props.contentData.sizeChartName || '') != (nextProps.contentData.sizeChartName || '')) {
      this.state.cachedSizeChart = '';
    }
  }

  openSizeChart() {
    if (this.state.cachedSizeChart) {
      this.props.passedAppFunctions.setModalInfo(this.state.cachedSizeChart);
    } else {
      this.props.passedAppFunctions.toggleTransition();
      var axiosOptions = {
        method: 'get',
        url: `/webapp/wcs/stores/servlet/NonCacheESpot?emsName=${this.props.contentData.sizeChartName}&maxNumDisp=1&storeId=301&catalogId=301&langId=-1`,
      };
      axios(axiosOptions).then((ajaxResponse) => {
        var cmdRespIsJSON;
        var responseJSON = {};
        try {
          responseJSON = typeof ajaxResponse.data == 'object' ? ajaxResponse.data : JSON.parse(ajaxResponse.data);
          cmdRespIsJSON = true;
        } catch (e) {}
        if (cmdRespIsJSON) {
          this.props.passedAppFunctions.toggleTransition();
          //update state with the new information
          responseJSON.modalType = 'SizeChart';
          this.state.cachedSizeChart = responseJSON;
          this.props.passedAppFunctions.setModalInfo(responseJSON);
          //MODAL
        } else {
          //something errored...
          this.props.passedAppFunctions.toggleTransition();
        }
      });
    }
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  componentDidUpdate() {
    if (this.props.contentData.productId != this.state.productId) {
      this.setState({
        productId: this.props.contentData.productId,
      });
    }
    if (typeof zonos === 'object') {
      setTimeout(() => {
        zonos.displayCurrency();
      }, 100);
    }
  }

  getAvailableValues(attrName) {
    let otherSelectedAttributes = Object.values(this.props.passedFunctions.parentState.currentAttributeState).filter(
      (selectedAttr) => {
        return selectedAttr.attrName !== attrName && selectedAttr.selectedValue;
      }
    );

    let getAllSkus = this.props.passedFunctions.parentState.availableValues;
    let skusWithAllValues = [];

    Object.values(getAllSkus).map((sku) => {
      let containsAllValues = true;
      sku.values.map((vals) => {
        otherSelectedAttributes.map((selectedAttr) => {
          if (vals.name === selectedAttr.attrName && vals.value !== selectedAttr.selectedValue) {
            containsAllValues = false;
          }
        });
      });
      if (containsAllValues) {
        skusWithAllValues.push(sku);
      }
    });

    let availableValues = [];
    skusWithAllValues.map((sku) => {
      sku.values.map((attr) => {
        if (attr.name === attrName) {
          availableValues.push(attr.value);
        }
      });
    });

    availableValues = Array.from(new Set(availableValues));
    return availableValues;
  }

  getOneAttrPricing() {
    let curPriceVals = [];
    let price, minPrice, maxPrice, attrName, attrVal, attrStr;
    Object.values(this.props.contentData.skus).forEach((sku) => {
      price = sku.offer.price;
      minPrice = price;
      maxPrice = price;
      attrName = sku.definingAttributes[0].name;
      attrVal = sku.definingAttributes[0].value.value;
      attrStr = { attrName, attrVal, price, minPrice, maxPrice };
      curPriceVals.push(attrStr);
    });
    return curPriceVals;
  }

  buildPriceObj() {
    let curAttrState = this.props.currentAttributeState;
    let allSkus = this.props.contentData.skus;
    let priceForDisp = {};
    const skustoPrice = allSkus.filter((sku) => {
      let hasAllAttrs = Object.keys(curAttrState).every((attrName) => {
        let hasAllSelAttributes = true;
        sku.definingAttributes.forEach((attr) => {
          if (
            curAttrState[attrName].selectedValue &&
            attr.name === attrName &&
            curAttrState[attrName].selectedValue !== attr.value.value
          ) {
            hasAllSelAttributes = false;
          }
          return curAttrState[attrName].selectedValue !== attr.value.value;
        });
        return hasAllSelAttributes;
      });
      return hasAllAttrs;
    });
    let priceRange = this.getPricing(skustoPrice);
    const otherSkus = allSkus.filter((sku) => {
      let hasSomeAttrs = Object.keys(curAttrState).some((attrName) => {
        let hasSomeAttributes = false;
        sku.definingAttributes.forEach((attr) => {
          if (
            curAttrState[attrName].selectedValue &&
            attr.name === attrName &&
            curAttrState[attrName].selectedValue === attr.value.value
          ) {
            hasSomeAttributes = true;
          }
          return curAttrState[attrName].selectedValue === attr.value.value;
        });
        return hasSomeAttributes;
      });
      return hasSomeAttrs;
    });
    let allPrices = this.getPricing(otherSkus);

    Object.keys(allPrices).map((attrName) => {
      if (!priceForDisp?.[attrName]) {
        priceForDisp[attrName] = {};
      }
      Object.keys(allPrices?.[attrName]).map((attrVal) => {
        if (priceRange?.[attrName]?.[attrVal]) {
          priceForDisp[attrName][attrVal] = priceRange[attrName][attrVal];
        } else {
          priceForDisp[attrName][attrVal] = allPrices[attrName][attrVal];
        }
      });
    });
    return priceForDisp;
  }

  getPricing = (skus) => {
    let priceObj = {};
    skus.forEach((sku) => {
      sku.definingAttributes.forEach((defAttr) => {
        let price = sku.offer.price;
        let attrName = defAttr.name;
        let attrVal = defAttr.value.value;
        if (priceObj[attrName]) {
          if (priceObj[attrName][attrVal]) {
            const currentMin = priceObj[attrName][attrVal].minPrice;
            const currentMax = priceObj[attrName][attrVal].maxPrice;
            if (price > currentMax) {
              priceObj[attrName][attrVal].maxPrice = price;
            }
            if (price < currentMin) {
              priceObj[attrName][attrVal].minPrice = price;
            }
          } else {
            priceObj[attrName][attrVal] = { attrVal, minPrice: price, maxPrice: price };
          }
        } else {
          priceObj[attrName] = {};
          priceObj[attrName][attrVal] = { attrVal, minPrice: price, maxPrice: price };
        }
      });
    });
    return priceObj;
  };

  getAttributeValues(attrVals) {
    let valsArr = [];
    attrVals.sort((a, b) => (a.sequence - b.sequence == 0 ? a.value.localeCompare(b.value) : a.sequence - b.sequence));
    attrVals.map((val) => {
      if (!valsArr.includes(val.value)) {
        valsArr.push(val.value);
      }
    });
    return valsArr;
  }

  getProductType() {
    return this.props.currentAttributeState;
  }

  render() {
    return (
      <>
        {Object.values(this.props.passedFunctions.parentState.attributesMain).map((attr, i) => (
          <div key={attr.name}>
            {(attr.displayStyle.toLowerCase() === 'flat' && !this.props.quickView && !this.props.isBundle) ||
            (attr.displayStyle.toLowerCase() === 'flat' &&
              this.props.passedAppFunctions.siteFormat === 'mobile' &&
              !this.props.isBundle) ? (
              <AttributeButton
                attribute={attr}
                contentData={this.props.contentData}
                passedFunctions={this.props.passedFunctions}
                passedAppFunctions={this.props.passedAppFunctions}
                getAttributeValues={this.getAttributeValues}
                availableValues={this.getAvailableValues(attr.name)}
                currentAttributeState={this.props.currentAttributeState}
                changeAttributeState={this.props.passedFunctions.changeAttributeState}
                selectedAttributeValue={this.state.selectedAttributeValue}
                openSizeChart={this.openSizeChart}
                isQuickView={this.props.quickView}
                isBundle={this.props.isBundle}
              />
            ) : null}
            {(attr.displayStyle.toLowerCase() === 'dropdown' ||
              attr.displayStyle === '' ||
              (this.props.quickView && this.props.passedAppFunctions.siteFormat !== 'mobile') ||
              this.props.isBundle) && (
              <>
                <AttributeDropDown
                  attribute={attr}
                  contentData={this.props.contentData}
                  passedFunctions={this.props.passedFunctions}
                  passedAppFunctions={this.props.passedAppFunctions}
                  getAttributeValues={this.getAttributeValues}
                  availableValues={this.getAvailableValues(attr.name)}
                  currentAttributeState={this.props.currentAttributeState}
                  changeAttributeState={this.props.passedFunctions.changeAttributeState}
                  selectedAttributeValue={this.state.selectedAttributeValue}
                  openSizeChart={this.openSizeChart}
                  isQuickView={this.props.quickView}
                  isBundle={this.props.isBundle}
                  priceForDisplay={this.buildPriceObj()}
                  oneAttrPricing={this.getOneAttrPricing()}
                />
                {attr.name == 'Color' &&
                  !this.props.isBundle &&
                  !(
                    this.props.passedAppFunctions.quickviewIsOpen &&
                    (this.props.passedAppFunctions.siteFormat == 'tablet' ||
                      this.props.passedAppFunctions.siteFormat == 'mobile')
                  ) && (
                    <ProductDetailSwatches
                      swatchGroups={this.props.passedFunctions.parentState.swatchGroups}
                      attribute={attr}
                      contentData={this.props.contentData}
                      passedFunctions={this.props.passedFunctions}
                      passedAppFunctions={this.props.passedAppFunctions}
                      getAttributeValues={this.getAttributeValues}
                      availableValues={this.getAvailableValues(attr.name)}
                      currentAttributeState={this.props.currentAttributeState}
                      changeAttributeState={this.props.passedFunctions.changeAttributeState}
                      selectedAttributeValue={this.state.selectedAttributeValue}
                      openSizeChart={this.openSizeChart}
                      isQuickView={this.props.quickView}
                      isBundle={this.props.isBundle}
                    />
                  )}
              </>
            )}
          </div>
        ))}
      </>
    );
  }
}

export default ProductDetailAttribute;
